import { Logo } from '@/components';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SnackbarProvider } from '../context/SnackbarContext';

/**
 * Clean, standalone layout for magic link pages
 * Designed for teachers accessing upload portals via email links
 * No authentication or complex navigation required
 */
const MagicLinkLayout: React.FC = () => {
  return (
    <SnackbarProvider>
      <Box sx={{
        minHeight: '100vh',
        backgroundColor: '#fafafa',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <Box sx={{
          backgroundColor: 'background.paper',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
          py: 2
        }}>
          <Container maxWidth="lg">
            <Stack direction="row" alignItems="center" justifyContent="center">
              <Logo />
            </Stack>
          </Container>
        </Box>

        {/* Main Content */}
        <Box sx={{ flex: 1, py: { xs: 3, md: 6 } }}>
          <Container maxWidth="md">
            <Outlet />
          </Container>
        </Box>

        {/* Footer */}
        <Box sx={{
          backgroundColor: 'background.paper',
          borderTop: '1px solid rgba(0, 0, 0, 0.08)',
          py: 3,
          mt: 'auto'
        }}>
          <Container maxWidth="lg">
            <Stack direction="column" spacing={2} alignItems="center">
              <Stack direction="row" spacing={3} alignItems="center">
                <Typography variant="body2" color="text.secondary">
                  Powered by Zube AI
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  •
                </Typography>
                <Link
                  href="mailto:support@getzube.com"
                  variant="body2"
                  color="primary.main"
                  sx={{ textDecoration: 'none' }}
                >
                  Need help? Contact us
                </Link>
              </Stack>
            </Stack>
          </Container>
        </Box>
      </Box>
    </SnackbarProvider>
  );
};

export default MagicLinkLayout;